import { FC } from 'react';
import DataTable from '@/components/customUI/DataTable';
import useGetTableColumns from '@/hooks/useGetTableColumns';
import { originalCols } from '@/lib/main';
import { ObisCodeMapType } from '@/store/hes/types/other';
import SpecialCommands from './includes/Special-commands';
import CommandResponseForAllEventPull from './includes/Special-commands/All-event-pull';
import { ExecutionHistoryDetailRecordModified } from '@/pages/hes/command/includes/utils';
import { formatDate } from '@/lib/utils/dateTime';
import { allowedCommandsForOBISDownload } from '../lib';

type CommandResponseTableRecord = {
  [key: string]: string | number;
};

type CommandResponseTableProps = {
  data: ExecutionHistoryDetailRecordModified | CommandResponseTableRecord[];
  isFailedCommnad: boolean;
  specialCommandsData?:
    | { [key: string]: { [key: string]: Record<string, string | number> } }
    | undefined;
  obisCodeMap?: ObisCodeMapType;
  parent?: string;
  keyOrder?: string[];
  title: string;
  idForDownloadButton?: string;
  commandName: string;
};

const specialCommandsArray = [
  'READ PASSIVE DAY PROFILE',
  'MR READ PASSIVE TOU DAY PROFILE',
  'MR READ ACTIVITY CALENDAR FOR TIME ZONES',
  'READ ACTIVE TOU DAY PROFILE',
  'READ PASSIVE TOU DAY PROFILE'
];

const CommandResponseTable: FC<CommandResponseTableProps> = ({
  data,
  obisCodeMap,
  commandName,
  keyOrder,
  title,
  isFailedCommnad,
  idForDownloadButton,
  specialCommandsData,
  parent
}) => {
  if (['ALL EVENT PULL'].includes(commandName)) {
    return (
      <CommandResponseForAllEventPull
        data={data as ExecutionHistoryDetailRecordModified}
        keyOrder={keyOrder}
        failedReason={
          isFailedCommnad
            ? (data as { [key: string]: string }[])[0].message
            : undefined
        }
        obisCodeMap={obisCodeMap || []}
      />
    );
  }
  if (specialCommandsArray.includes(commandName)) {
    return (
      <SpecialCommands
        obisCodeMap={obisCodeMap || []}
        keyOrder={keyOrder}
        failedReason={
          isFailedCommnad
            ? (data as { [key: string]: string }[])[0].message
            : undefined
        }
        data={specialCommandsData}
      />
    );
  }
  const columns = useGetTableColumns({
    cols: data as CommandResponseTableRecord[],
    query: [],
    colsToFormat: {
      cols: ['executionEndTime', 'executionStartTime'],
      formatterFunc(val) {
        return formatDate(val, 'DD-MM-YYYY HH:mm:ss');
      }
    },
    originalCols: originalCols
  });
  return (
    <div>
      <DataTable
        hasInternalPagination={parent === 'sat' ? true : false}
        idForDownloadDropdown={`command-response-download-data-fe-drp-dwn-menu${idForDownloadButton}`}
        title={title}
        obisCodeMap={obisCodeMap}
        data={data as CommandResponseTableRecord[]}
        columns={columns}
        isDownloadable={
          allowedCommandsForOBISDownload.includes(commandName) ? false : true
        }
        columnOrder={keyOrder}
      />
    </div>
  );
};

export default CommandResponseTable;
